<template>
  <div class="home">
    <!-- 引用三维 -->
    <iframe src="mms3D/index.html" frameborder="0" id="iframe" style="width: 100vw; height: 100vh"
      class="iframe"></iframe>
    <div v-if="isShow">
    <!-- <div v-if="true"> -->
      <TopHead />
      <!-- 右边按钮 -->
      <div class="panorama">
        <div class="btn" @click="loginOut"><span>退出</span></div>
        <div class="btn" @click="resetView()"><span>全景</span></div>
      </div>
      <!-- 报警信息图标 -->
      <div class="warning" @click="openWarningTab">
        <!-- 两条椭圆的线 -->
        <div class="line1 line"></div>
        <div class="line2 line"></div>
        <!-- 中间的图标 -->
        <div class="circle">
          <!-- 外层呼吸灯div -->
          <div class="circle_l"></div>
          <!-- 最中间扩散动画div -->
          <div class="circle_anmation"></div>
        </div>
        <span>总数：<span>3</span></span>
      </div>
      <!-- 页面最外层阴影边框背景 -->
      <img id="page_left_back" src="@/assets/img/left_back.png" v-show="leftAndRightShow" />
      <img id="page_right_back" src="@/assets/img/right_back.png" v-show="leftAndRightShow" />
      <div class="page_bottom">
        <img id="bottom_border" src="@/assets/img/bottom_border.png" />
      </div>
      <!-- 底部按钮 -->
      <BottomSection @resetView="resetView" />
      <router-view></router-view>
    </div>
    <WarningTab ref="warningTab" />
  </div>
</template>

<script>
// @ is an alias to /src
import BottomSection from "@/components/bottomSection/index.vue";
import TopHead from "@/components/TopHead.vue";
import WarningTab from "@/components/WarningTab.vue";
import {singleDeviceRealApi} from "@/api/basic.js"
export default {
  name: "HomeView",
  components: {
    BottomSection,
    TopHead,
    WarningTab,
  },
  computed: {
    // 监听vuex 控制左右板块是否显示
    leftAndRightShow() {
      return this.$store.state.bothEndsShow;
    },
  },
  data() {
    return {
      // 控制二维内容显示
      isShow: false,
    };
  },
  created() {
    window.twoDShow = this.twoDShow;
  },
  mounted(){
    // singleDeviceRealApi({equipmentid:'00e5ed0d-44cd-495f-b5b8-3ddfc0c52a64'}).then(res=>{
    //   console.log(res)
    // })
  },
  methods: {
    // 三维加载成功后掉用此方法，显示二维
    twoDShow() {
      this.isShow = true;
    },
    // 重置三维场景视角
    resetView(path) {
      // 当子组件调用时传来路由，则路径为子组件传来的路由，否则获取当前页面路由
      if (!path) {
        path = this.$route.path
      }
      document
        .getElementById("iframe")
        .contentWindow.MMAPI.resView(path);
    },
    // 退出登录
    loginOut() {
      // 存入token
      sessionStorage.removeItem("token");
      // 路由跳转
      this.$router.push({ path: "/login" });
    },
    // 打开报警记录弹框
    openWarningTab() {
      this.$refs.warningTab.openThis();
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  height: 100vh;

  // background-image: url("@/assets/img/back.jpg");
  // background-size: 100% 100%;
  #page_left_back {
    width: 570px;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
  }

  #page_right_back {
    width: 484vw * @vw;
    height: 100vh;
    position: fixed;
    top: 0;
    right: 0;
  }

  .page_bottom {
    width: 100%;
    height: 458vh * @vh;
    // background-image: url("@/assets/img/bottom_back.png");
    // background-size: 100% 100%;
    background-image: linear-gradient(to bottom,
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 1) 95%);
    // background: #000;
    position: fixed;
    bottom: -58.33vh * @vh;

    #bottom_border {
      width: 5705px;
      height: 132vh * @vh;
      position: fixed;
      bottom: 45vh * @vh;
      left: 26px;
    }
  }

  // 按钮图片
  .panorama {
    cursor: pointer;
    position: fixed;
    right: 60px;
    top: 144vh * @vh;
    width: 280px;
    z-index: 1;
    display: flex;
    justify-content: space-between;

    &>.btn {
      width: 90px;
      // height: 105vh * @vh;
      height: 105px;
      background-image: url("@/assets/img/right_btn_back.png");
      background-size: 100% 100%;
      cursor: pointer;
      // line-height: 105vh * @vh;
      line-height: 105px;
      text-align: center;
      font-size: 25px;

      span {
        background: linear-gradient(to bottom, #fff 20%, #008fff);
        text-align: center;
        font-size: 30px;
        -webkit-background-clip: text;
        color: transparent;
      }
    }
  }

  // 报警图标动画
  @keyframes bigBoxAnmaiton {
    50% {
      opacity: 1;
    }

    100% {
      width: 300px;
      height: 300px;
      opacity: 0;
    }
  }

  @keyframes zhuan2 {
    to {
      transform: rotateX(100deg) rotateY(-15deg) rotateZ(-360deg);
    }
  }

  @keyframes zhuan1 {
    to {
      transform: rotateX(100deg) rotateY(15deg) rotateZ(360deg);
    }
  }

  @keyframes circleAnmation {
    to {
      top: 50%;
    }
  }

  @keyframes lightAnmation {
    to {
      opacity: 0;
    }
  }

  // 报警图标
  .warning {
    width: 491px;
    height: 360px;
    position: fixed;
    right: 1100px;
    bottom: 352vh * @vh;
    cursor: pointer;
    z-index: 1;

    div {
      position: absolute;
    }

    // 两条线的样式
    .line {
      width: 493px;
      height: 493px;
      border-radius: 50%;
      /* 圆锥渐变 */
      background: conic-gradient(rgb(255, 255, 255) 20%,
          rgb(167, 186, 248),
          rgb(95, 132, 252),
          rgb(167, 186, 248));
      /* 将圆中心“掏空”变成圆环 */
      --mask: radial-gradient(closest-side, transparent 97%, black 97%);
      -webkit-mask-image: var(--mask);
      mask-image: var(--mask);
    }

    .line1 {
      transform: rotateX(100deg) rotateY(15deg);
      animation: zhuan1 5s linear infinite;
    }

    .line2 {
      transform: rotateX(100deg) rotateY(-15deg);
      animation: zhuan2 5s linear infinite;
    }

    // 中间的图标
    .circle {
      top: 55%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 360px;
      height: 360px;
      background-image: url("@/assets/img/warning_circle.png");
      background-size: 100% 100%;
      position: relative;
      animation: circleAnmation 2s infinite ease-in-out alternate;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    // 图标中间扩散动画
    .circle_anmation {
      width: 110px;
      height: 110px;
      border-radius: 50%;
      border: 1px solid rgb(238, 27, 27);
      animation: bigBoxAnmaiton 4s infinite ease-in-out;
      box-shadow: 0px 0px 30px rgb(247, 36, 36);
      opacity: 0.2;
    }

    // 中间图标外部高亮
    .circle_l {
      width: 300px;
      height: 300px;
      border-radius: 50%;
      box-shadow: 0px 0px 30px rgba(255, 255, 255, 0.9);
      animation: lightAnmation 2s infinite linear alternate;
    }

    &>span {
      position: absolute;
      top: -34vh * @vh;
      right: 55px;
      font-size: 24px;
      color: #fff;

      &>span {
        font-size: 48px;
      }
    }
  }
}</style>
